module.exports = __webpack_public_path__ + "static/media/verified_user.ec5dffe6.svg";